import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, NgForm, Validators, AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { Subscription, Observable, of } from 'rxjs';
import { EditorComponent } from "@progress/kendo-angular-editor";
import { UploadImageDialogComponent } from "editor-library";
const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/';
import { ToastrService } from 'ngx-toastr';
import { EmailClientService } from "../service/email-client.service";
import { TemplateService } from "src/app/services/template.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CustomErrorToastComponent } from "custom-error-toast";

@Component({
  selector: "outlook-compose-email",
  templateUrl: "./outlook-compose-email.component.html",
  styleUrls: ["./outlook-compose-email.component.scss"],
})
export class OutlookComposeEmailComponent implements OnInit, OnDestroy {
  commonkendoeditorStr: string;
  // isUnified: boolean = false;
  @Output() @ViewChild("commonkendoeditor") public commonkendoeditor: EditorComponent;
  @ViewChild("commonkendoeditorupload") public commonkendoeditorupload: UploadImageDialogComponent;
  @Output() deleteMailDetails = new EventEmitter<any>()
  replyForm: FormGroup;
  discardDialog: boolean = false;
  userName: string = '';
  userEmail: string = '';
  submitted: boolean = false;
  replyType: string = '';
  uploadedFile: any;
  attachFileList: any[] = [];
  mailId: string = '';
  subjectId: string = '';
  uploadedFiles$: Observable<any>;
  acceptedFiles: string = ".pdf, .jpg, .png, .doc, .docx, .xls, .xlsx,.csv";
  emailDetailSubscription: Subscription;
  templateList=[];
  priorityList = [
    {
      name: "Normal",
      code: "normal",
    },
    {
      name: "High",
      code: "high",
    },
    {
      name: "Low",
      code: "low",
    },
  ];
  getEmailDetailsSub: Subscription;
  id: string;
  isEmailToError: boolean = false;
  isEmailFromError: boolean = false;

  constructor(private fb: FormBuilder,
    private toastr: ToastrService,
    private templateService: TemplateService,
    private router: Router,
    private route: ActivatedRoute,
    private emailClientService: EmailClientService,
   ) {
  }

  ngOnInit(): void {
    let emailregex: RegExp = /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([,.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
    this.replyForm = this.fb.group({
      from: [this.emailClientService.selectedUsername  , [Validators.required, Validators.email]],
      priority: ['normal'],
      templateName: [''],
      to: ['', {
        validators: [Validators.required, Validators.pattern(emailregex), this.checkduplicateEmail()],
        updateOn: 'blur'
      }],
      cc: ['', {
        validators: [Validators.pattern(emailregex), this.checkduplicateEmail()],
        updateOn: 'blur'
      }],
      subject: ['', Validators.required],
      editor: ['']
    });
    // this.emailClientService.emailDetailSubscription$.subscribe(data => {
    //   this.mailId = data['emailId'];
    //   this.replyType = data['replyType'];
    //   if (this.mailId) {
    //     this.getEmailDetails(this.mailId);
    //   }
    // })
    if(this.emailClientService.selectedReplyType){
      this.getEmailDetails(this.emailClientService.selectedEmailId);
    }
    this.subjectId ='[3126IMAGILITY]';

    // get the template list.
    this.getTemplateList()

  }

  // close(){
  //   this.modalService.close();
  // }

  getTemplateList(){
    const payload = {
      "superTaskTypeId": "EMALTEMPLT",
      "isDefault": "false",
      "pageNumber": 1,
      "recordsPerPage": 100,
      "searchText": ""
    }
    this.templateService.getEmailTemplateList(payload, '').subscribe(data => {
      console.log('data', data['documentTemplate']);
      data['documentTemplate'].forEach(element => {
        element.documentType = element.documentType.code;
        element.templateType = element.templateType.code;
        // console.log("element===>",JSON.parse(element.communicationJson));
        // console.log("element===>",element);
        this.templateList.push(element);
      });
    });
  }


  navigate() {
    if (sessionStorage.getItem('userTypeRole') === 'Attorney') {
        window.open(window.location.origin + '/attorney-landing/template/template-form', '_blank');
    }
    else if (sessionStorage.getItem('userTypeRole') === 'Petitioner'){
      window.open(window.location.origin + '/petitioner-landing/template/template-form', '_blank');
    }
  }

  onSelectEmailTemplate(event) {
    console.log(event.value);
    this.templateService.fetchEmailTemplate(event.value).subscribe((res: any) => {
      if(res){
        this.replyForm.controls['to'].setValue(res.communicationDTO?.toMail);
        // this.replyForm.controls['from'].setValue(res.communicationDTO.fromMail);
        this.replyForm.controls['subject'].setValue(res?.contentMap?.header);
        this.replyForm.controls['editor'].setValue(res?.contentMap?.body +'\n' + res.contentMap?.footer);
      }
    });
  }

  validateEmailAddress(event, item){
    let inValidEmail = false;
    // if(event.value.match("[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}")){
    //   inValidEmail = false;
    // }else{
    //   inValidEmail = true;
    // }
    // switch(item){
    //   case 'from':
    //     this.isEmailFromError = inValidEmail;
    //   case 'to':
    //     this.isEmailToError = inValidEmail;
    //     if(inValidEmail){          
    //       this.replyForm.get('emailTo').value.pop();
    //     } 
    // }
    // this.replyForm.updateValueAndValidity();
  }

  // validateEmailAddress(event, item){
  //   if(item=='from'){
  //     let currentData;
  //     switch(this.template.defaultEmailFrom){
  //       case 'beneficiary':
  //         currentData = '${beneficiary_email}';
  //         break;
  //       case 'petitioner':
  //         currentData = '${petitioner_email}';
  //         break;
  //       case 'attorney':
  //         currentData = '${attorney_email}';
  //         break;
  //       case 'default':
  //         break;
  //     }
  //     if((event === currentData)){
  //       this.isEmailFromError = false;
  //     } else {
  //       if(event.match("[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}")){
  //         this.isEmailFromError = false;
  //       } else {
  //         if(event=="" || !event){
  //           this.template.emailFrom = null;
  //           this.isEmailFromError = true;
  //         } else{
  //           this.isEmailFromError = true;
  //         }
  //       }
  //     }
  //   } else {
  //     let currentData;
  //     switch(this.template.defaultEmailTo){
  //       case 'beneficiary':
  //         currentData = '\W*\([$]{beneficiary_email})\W*';
  //         break;
  //       case 'petitioner':
  //         currentData = '\W*\([$]{petitioner_email})\W*';
  //         break;
  //       case 'attorney':
  //         currentData = '\W*\([$]{attorney_email})\W*';
  //         break;
  //       case 'default':
  //         break;
  //     }
  //     if(event.value.match(`${currentData}|[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}`)){
  //       this.isEmailToError = false;
  //     } else {
  //       this.template.emailTo.pop();
  //       if(this.template.emailTo.length>0){
  //         this.isEmailToError = false;
  //       } else {
  //         this.template.emailTo = [];
  //         this.isEmailToError = true;
  //       }
  //     }
  //   }
  // }

  getEmailDetails(mailId: string) {
    this.getEmailDetailsSub = this.emailClientService.getMessageDetails(mailId).pipe().subscribe(emailData => {
      this.setFormData(emailData);
      this.subjectId ='[3126IMAGILITY]';
    })
  }

  setFormData(emailData: any) {
    let toEmail = '';
    let ccEmail = '';
    let subject = '';
    this.replyType =  this.emailClientService.selectedReplyType;
    if (this.replyType == 'replyAll') {
      // emailData.toRecipients.push(emailData.from);
      let emailToAppend='';
      toEmail = this.combineEmails(emailData.toRecipients);
      // toEmail = emailData.toRecipients;
      if(emailData.From && toEmail){
        emailToAppend = toEmail.includes(emailData.From) 
                            ? toEmail
                            : toEmail +","+ emailData.From;
        toEmail= emailToAppend;
      }
      ccEmail = this.combineEmails(emailData.ccRecipients);
      // ccEmail = emailData.ccRecipients;
      subject = "RE: " + emailData?.subject;
    }
    else if (this.replyType == 'reply') {
      toEmail = emailData?.from?.emailAddress?.address;
      ccEmail = '';
      subject = "RE: " + emailData?.subject;
    }
    else if (this.replyType == 'forward') {
      toEmail = '';
      ccEmail = '';
      subject = "FW: " + emailData?.subject;
    }
    this.setAttachments(emailData.id);
    this.replyForm.patchValue({
      from: this.emailClientService.selectedUsername,
      to: toEmail,
      cc: ccEmail,
      subject: subject,
      priority: emailData.importance,
      editor: emailData?.body?.content
    });
    this.replyForm.markAsTouched();
  }

  setAttachments(id: string) {
    this.emailClientService.getEmailAttachments(id).subscribe(attachments => {
      for (let attachment of attachments.value) {
        this.attachFileList.push(
          {
            "@odata.type": "#microsoft.graph.fileAttachment",
            "name": attachment['name'],
            "contentType": attachment['contentType'],
            "contentBytes": attachment['contentBytes']
          }
        )
      }
      this.uploadedFiles$ = of(this.attachFileList);
    })
  }

  combineEmails(emailAddress: any): any {
    let emailArr = [];
    for (let email of emailAddress) {
      emailArr.push(email.emailAddress.address);
    }
    return emailArr;
    // return emailArr.join(',');
  }

  onSave() {
    this.submitted = true;    
      let composeFormData = this.replyForm.value;
      this.emailClientService.selectedReplyType=''; // reset reply
      // let fromEmailArr = this.commonEmailBuild([this.replyForm.value.from]);
      let toEmails = this.replyForm.value.to;//.split(",")
      let ccEmails = this.replyForm.value.cc ? this.replyForm.value.cc: '';
      let ccEmailArr = ccEmails ? this.commonEmailBuild(ccEmails) : [];
      let toEmailArr = this.commonEmailBuild(toEmails);
      let subject = '';
      if (this.replyType) {
        subject = composeFormData.subject;
      }
      else {
        subject = this.subjectId + " " + composeFormData.subject;
      }
      const message = {
        "subject": subject,
        "body": {
          "contentType": "HTML",
          "content": composeFormData.editor
        },
        "importance": composeFormData.priority,
        // "from": [...fromEmailArr],
        "toRecipients": [...toEmailArr],
        "ccRecipients": [...ccEmailArr],
        "attachments": this.attachFileList
      }
      this.emailClientService.saveEmail(message)
        .subscribe((message: any) => {
          if (message.status === 201) {
            this.toastr.success("Email Saved successfully.", 'Success');
            this.emailClientService.emailDetailSubscription$.next(
              { read: false, emailType: 'Drafts' });
          }
        },
          (error) => {
            CustomErrorToastComponent.showErrorToast(this.toastr, 'Problem occured while saving email.');
          }
        );   
  }


  deleteFile(index: number) {
    this.uploadedFiles$.subscribe(attachmentData => {
      attachmentData.splice(index, 1);
      this.uploadedFiles$ = of(attachmentData);
      this.attachFileList = attachmentData;
    })
  }

  onSend() {
    this.submitted = true;
    if (this.replyForm.valid) {
      let composeFormData = this.replyForm.value;
      this.emailClientService.selectedReplyType=''; // reset reply
      let toEmails = this.replyForm.value.to; //.split(",")
      let ccEmails = this.replyForm.value.cc ? this.replyForm.value.cc : '';
      let ccEmailArr = ccEmails ? this.commonEmailBuild(ccEmails) : [];
      let toEmailArr = this.commonEmailBuild(toEmails);
      const message = this.getPayload(composeFormData, toEmailArr, ccEmailArr);
      if (this.replyType) {
        this.mailId = this.emailClientService.selectedEmailId;
        this.emailClientService.sendReplyAndForwardEmail(message, this.mailId, this.replyType)
          .subscribe((message: any) => {
            if (message.status === 202) {
              if(this.emailClientService.preservedMsgTypeForDraft=="Drafts"){
                this.emailClientService.preservedMsgTypeForDraft='';
                this.toastr.success("Email sent successfully.", 'Success');
              }
              else {
                this.toastr.success("Reply sent successfully.", 'Success');
              }
              this.emailClientService.folderChangeSubject$.next(true);
              this.emailClientService.emailDetailSubscription$.next(
                { read: false, emailType: 'Inbox' });
            }
          },
            (error) => {
              CustomErrorToastComponent.showErrorToast(this.toastr, 'Problem occured while sending email.');
            }
          );
      }
      else {
        this.emailClientService.sendEmail(message)
           .subscribe((message: any) => {
            if (message.status === 202) {
              this.toastr.success("Email sent successfully.", 'Success');
              setTimeout(()=>{
              this.emailClientService.folderChangeSubject$.next(true);
                this.emailClientService.emailDetailSubscription$.next(
                  { read: false, emailType: 'Sent Items' });
              },100)
            }
          },
             (error) => {
               CustomErrorToastComponent.showErrorToast(this.toastr, 'Problem occured while sending email.');
             }
           );
      }
    }else if(this.replyForm.controls.to.value == this.replyForm.controls.cc.value){
      CustomErrorToastComponent.showErrorToast(this.toastr, 'Email To and CC can not be the same.');
    }   
    else {
      CustomErrorToastComponent.showErrorToast(this.toastr, 'please fill all mandatory filelds.');
    }
  }

  commonEmailBuild(emails: string[]) {
    const emailArr = [];
    for (let email of emails) {
      let mailObj = { emailAddress: {} };
      mailObj['emailAddress'] = {
        "address": email
      }
      emailArr.push(mailObj);
    }
    return emailArr;
  }

  getPayload(composeFormData: any, toEmailArr: any, ccEmailArr: any): any {
    const disclaimerMsg ="Removing Id between square bracket will be loose entire chain,please don't delete it.";
    const disclaimer=`\n<font color='black'><b>Disclaimer</b>:${disclaimerMsg}</font>`; 
    let editorValue= '';
    if(composeFormData.editor.includes(disclaimerMsg)){
      editorValue= composeFormData.editor;
    }
    else {
      editorValue= composeFormData.editor +"<br>"+disclaimer;
    }
    let subject = '';
    if (this.replyType) {
      subject = composeFormData.subject;
    }
    else {
      subject = this.subjectId + " " + composeFormData.subject;
    }
    return {
      "message": {
        "subject": subject,
        "isRead": false,
        "body": {
          "contentType": "html",
          "content": editorValue
        },
        "importance": composeFormData.priority,
        "from": {
          "emailAddress": {
            "name": this.userName,
            "address": composeFormData.from
          }
        },
        "toRecipients": [...toEmailArr],
        "ccRecipients": [...ccEmailArr]
        ,
        "attachments": this.attachFileList
      },
      "saveToSentItems": "true"
    }
  }

  onCancel() {
    this.discardDialog = true;
  }

  getBase64(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  Upload(event, fileUpload) {
    fileUpload.clear();
    const fileArr = Array.from(event.files);
    fileArr.forEach((file: any) => {
        this.getBase64(file).then((reader: string) => {
          this.attachFileList.push({
            "@odata.type": "#microsoft.graph.fileAttachment",
            "name": file.name,
            "contentType": file.type,
            "contentBytes": reader.replace('data:', '').replace(/^.+,/, '')
          })
        })
    })
    this.uploadedFiles$ = of(this.attachFileList);
  }

  discard() {
    this.replyForm.patchValue({
      to: '',
      priority: 'normal',
      cc: '',
      subject: '',
      editor: " "
    });
    this.commonkendoeditor.value="";
    this.uploadedFiles$ = of([]);
    this.discardDialog = false;
    this.replyForm.markAsUntouched();
    this.emailClientService.folderChangeSubject$.next(true);
  }
  commonkendoeditorimageuploaddialog() {
    this.commonkendoeditorupload.open();
  }

  checkduplicateEmail(): ValidatorFn {
    return (group: FormGroup): { [s: string]: boolean } => {
      if (this.replyForm) {
        const to = this.replyForm.get('to').value
        const cc = this.replyForm.get('cc').value
        if (to != null && cc != null) {
          if (to && cc) {
            let toArr = to;//.split(",")
            for (let toEmail of toArr) {
              if (cc.includes(toEmail)) {
                return { duplicateEmail: true };
              }
            }
          }
        }
        // else if(to!=null && cc==null ){
        //   return { duplicateEmail: false };
        // }
      }
      return null;
    };
  }

  ngOnDestroy() {
    if(this.getEmailDetailsSub)
      this.getEmailDetailsSub.unsubscribe();
  }
}